import React from 'react';

const TokenomicsCommand = () => {
  return (
    <div className="overview-container">
      <pre className="ascii-art">
{`████████╗ ██████╗ ██╗  ██╗███████╗███╗   ██╗ ██████╗ ███╗   ███╗██╗ ██████╗███████╗
╚══██╔══╝██╔═══██╗██║ ██╔╝██╔════╝████╗  ██║██╔═══██╗████╗ ████║██║██╔════╝██╔════╝
   ██║   ██║   ██║█████╔╝ █████╗  ██╔██╗ ██║██║   ██║██╔████╔██║██║██║     ███████╗
   ██║   ██║   ██║██╔═██╗ ██╔══╝  ██║╚██╗██║██║   ██║██║╚██╔╝██║██║██║     ╚════██║
   ██║   ╚██████╔╝██║  ██╗███████╗██║ ╚████║╚██████╔╝██║ ╚═╝ ██║██║╚██████╗███████║
   ╚═╝    ╚═════╝ ╚═╝  ╚═╝╚══════╝╚═╝  ╚═══╝ ╚═════╝ ╚═╝     ╚═╝╚═╝ ╚═════╝╚══════╝`}
      </pre>
      
      {/* Main Content Box */}
      <div className="content-box">
        <div className="box-header">
          🚀🚀 AIDER TOKEN: FUEL OF THE AI REVOLUTION 🚀🚀
        </div>

        <div className="box-content">
          <section className="feature-section">
            <h3>💎💎 Token Supply:</h3>
            <p>
              Total Supply: 1,000,000,000 AIDER<br />
              Initial Circulating Supply: 100,000,000 AIDER (10%)
            </p>
          </section>

          <section className="feature-section">
            <h3>📊📊 Distribution:</h3>
            <ul>
              <li>40% │████████████████████████████████████▌ | Community Rewards Pool</li>
              <li>20% │████████████████████▌                 | Team & Advisors</li>
              <li>15% │███████████████▌                      | Development Fund</li>
              <li>15% │███████████████▌                      | Marketing & Partnerships </li>
              <li>10% │██████████▌                           | Initial Exchange Offering</li>
            </ul>
          </section>

          <section className="feature-section">
            <h3>🔥🔥 Tokenomics Features:</h3>
            <ul>
              <li>Deflationary: 2% of each transaction burned</li>
              <li>Staking: Earn up to 20% APY by locking AIDER tokens</li>
              <li>Governance: AIDER holders vote on project decisions</li>
              <li>Permit: Implements EIP-2612 for gasless approvals</li>
            </ul>
          </section>

          <section className="feature-section">
            <h3>🚀🚀 Value Proposition:</h3>
            <p>
              The AIDER token isn't just a cryptocurrency – it's your ticket to
              the future of AI. As demand for our revolutionary decentralized
              AI services grows, so will the value of AIDER.
            </p>
          </section>

          <section className="feature-section prediction">
            <h3>💫💫 Opportunity:</h3>
            <p>
              Don't miss this opportunity to be part of the next tech revolution!
            </p>
          </section>

          <div className="disclaimer">
            Disclaimer: Cryptocurrency investments carry high risk. Past performance
            does not guarantee future results.
          </div>
        </div>
      </div>
    </div>
  );
};

export default TokenomicsCommand;